import Card from "components/Card/Card";
import React, { useEffect, useState, useRef } from "react";
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Row,
  Table,
  Button,
  Pagination,
} from "react-bootstrap";

import LoadingSpinner from "views/Components/loadingSpinner";
import NotificationSystem from "react-notification-system";
import ScreenLoader from "views/Components/screenLoader";
import Swal from "sweetalert2";
import {
  deleteLead,
  getClaimOrganizationList,
  GetPackages,
} from "../../../api/claimManager/ClaimManagerApi";
import Select from "react-select";

const ClaimEmployeeList = () => {
  const _notificationSystem = React.createRef();
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const [loading, setloading] = useState(false);
  const [noRecordFound, setnoRecordFound] = useState(false);
  const [organizationOption, setOrganizationOption] = useState([]);
  const [packageList, setPackageList] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState();
  const [searchLeads, setSearchLeads] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getClaimOrganizationListData();
  }, []);

  const getClaimOrganizationListData = async () => {
    getClaimOrganizationList(obj).then((res) => {
      const getClaimOrganizationOption = res.data.map((data) => {
        return {
          value: data.id,
          label: data.company_name,
        };
      });
      setOrganizationOption(getClaimOrganizationOption);
    });
  };

  const selectOrganization = (value) => {
    setSelectedOrganization(value);
    GetPackages(obj, value.value).then((res) => {
      // setCurrentPage(res.data.current_page);
      const data = res.data.data;
      setPackageList(Array.isArray(data) ? data : []);
    });
  };
  const deleteLeadWise = (id) => {
    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are Sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to delete this Lead</font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteleads(id);
      }
    });
  };
  const deleteleads = async (lead_id) => {
    const notification = _notificationSystem.current;
    const res = await deleteLead(lead_id, obj);
    if (res.data.success === true) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>Leads</b> - Deleted Successfully .
          </div>
        ),
        level: "success",
        position: "bl",
        autoDismiss: 15,
      });
      setloading(true);
      GetPackages(obj, selectedOrganization.value).then((res) => {
        const data = res.data.data;
        setPackageList(Array.isArray(data) ? data : []);
      });
      setloading(false);
    } else {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>{res.message || "Some Thing went Wrong"}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };
  const removeSelectOrganization = () => {
    setSelectedOrganization(null);
    setPackageList([]);
    setSearchLeads("");
  };

  useEffect(() => {
    getClaimOrganizationListData();
  }, []);

  const handleSearch = (event) => {
    const search = event.target.value;
    setSearchLeads(search);
    const orgValue =
      selectedOrganization && selectedOrganization.value
        ? selectedOrganization.value
        : "";
    GetPackages(obj, orgValue, search).then((res) => {
      setloading(true);
      const data = res.data.data;
      setPackageList(Array.isArray(data) ? data : []);
      setloading(false);
    });
  };

  return (
    <div className="main-content">
      <Grid fluid>
        <NotificationSystem ref={_notificationSystem} />
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}></Col>
          <Card
            content={
              <React.Fragment>
                <Row>
                  <Col
                    xs={12}
                    className="OrderList_fill"
                    style={{
                      padding: "18px",
                      borderRadius: "5px",
                      width: "100%",
                    }}
                  >
                    <Col md={3} sm={6} xs={12} style={{ marginTop: "3px" }}>
                      <Select
                        placeholder="Select Organization"
                        name="organization"
                        value={selectedOrganization}
                        onChange={(value) => selectOrganization(value)}
                        options={organizationOption}
                      />
                    </Col>
                    <Col md={3} sm={6} xs={12}>
                      <FormControl
                        name="searchLeads"
                        value={searchLeads}
                        placeholder="Search By Name,Email and Mobile"
                        onChange={(event) => handleSearch(event)}
                        type="text"
                        disabled={!selectedOrganization}
                      />
                    </Col>
                    <Col
                      md={3}
                      sm={4}
                      lg={3}
                      xs={12}
                      style={{ marginTop: "5px" }}
                    >
                      <Button
                        className="fl_btn_change_order_status btn-fill"
                        class="btn-color"
                        fill
                        onClick={removeSelectOrganization}
                      >
                        Reset
                      </Button>
                    </Col>
                  </Col>
                  <Col md={12}>
                    <Table responsive className="desktop-table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Mobile</th>
                          <th>Email</th>
                          {/* <th>Package</th> */}
                          <th style={{ textAlign: "center" }}>status</th>
                          <th>Created date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="10">
                              <LoadingSpinner />
                            </td>
                          </tr>
                        ) : noRecordFound || packageList.length === 0 ? (
                          <tr>
                            <td colSpan="10">
                              <center>No record found</center>
                            </td>
                          </tr>
                        ) : (
                          packageList &&
                          packageList.map((item) => (
                            <tr>
                              <td>{item.name}</td>
                              <td>{item.mobile_no}</td>
                              <td>{item.email}</td>
                              {/* <td>{item.package_logs}</td> */}
                              <td style={{ textAlign: "center" }}>
                                {item.claims_deleted_leads == null ? (
                                  <span
                                    style={{
                                      background: "green",
                                      padding: "8px 27px",
                                      color: "white",
                                      fontweight: "bold",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    Active
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      background: "red",
                                      padding: "8px 27px",
                                      color: "white",
                                      fontweight: "bold",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    Inactive
                                  </span>
                                )}
                              </td>
                              <td>{item.created_at}</td>
                              <td>
                                {item.claims_deleted_leads == null ? (
                                  <Button
                                    className="btn btn-fill fl_text_red"
                                    onClick={() => deleteLeadWise(item.id)}
                                  >
                                    Delete
                                    <i
                                      className="fa fa-trash"
                                      aria-hidden="true"
                                    ></i>
                                  </Button>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                {loading && <ScreenLoader />}
                {loading && <ScreenLoader />}
              </React.Fragment>
            }
          />
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Pagination bsSize="medium">{items}</Pagination>
          </div> */}
        </Row>
      </Grid>
    </div>
  );
};

export default ClaimEmployeeList;
